import { getGetDietAddonsQueryOptions } from "@repo/api/catalog/api/diet-addon-group";
import type { DietAddonGroupDietAddonsRead } from "@repo/api/catalog/api/schemas/diet-addon-group-diet-addons-read";
import type { QueryClient } from "@tanstack/react-query";

export const fetchDietAddonsByDietId = async (
  queryClient: QueryClient,
  dietIds: string[],
): Promise<Map<string, DietAddonGroupDietAddonsRead[]>> => {
  const uniqueIds = [...new Set(dietIds)];

  const entries = await Promise.all(
    uniqueIds.map(
      async (dietId): Promise<[string, DietAddonGroupDietAddonsRead[]]> => {
        try {
          const response = await queryClient.fetchQuery({
            ...getGetDietAddonsQueryOptions(dietId),
            staleTime: Number.POSITIVE_INFINITY,
          });
          return [dietId, response.data];
        } catch {
          return [dietId, []];
        }
      },
    ),
  );

  return new Map(entries);
};
